/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const headerGeographyDtoSchema = z.object({
  hq: z.optional(z.string()),
  presence: z.optional(z.array(z.string())),
  fullAddress: z.optional(z.string()),
  country: z.optional(z.string()),
  hqLocation: z.optional(z.string()),
  region: z.optional(z.string()),
  city: z.optional(z.string()),
  postalCode: z.optional(z.string()),
});
